let BASE_URL = process.env.VUE_APP_API_URL
let OSS_URL = process.env.VUE_APP_OSS_URL
let SER_API = process.env.VUE_APP_SER_API
let MALL_BASE_URL = process.env.VUE_APP_MALL_API_URL

export default {
  BASE_URL,
  OSS_URL,
  SER_API,
  MALL_BASE_URL
}

